import {sendDeleteRequest, sendGetRequest} from '../requests';

const baseUrl = '/notifications';

export const deleteNotification = (id: number) =>
  sendDeleteRequest(`${baseUrl}/${id}`);

export const getNotifications = (params) =>
  sendGetRequest(baseUrl, params);
